module.exports = __webpack_public_path__ + "img/img15.e6582367.svg";